/* eslint-disable no-empty */

import { PushNotifications } from "@capacitor/push-notifications";
import { Device } from "@capacitor/device";
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/functions";

export default {
  computed: {
    firebaseToken () {
      return this.$store.state.firebaseToken;
    },
  },
  methods: {
    async sendTokenToServer(token) {
      let firebaseToken = JSON.parse(JSON.stringify(this.firebaseToken));

      if (firebaseToken.current !== null) {
          firebaseToken.old.push(firebaseToken.current);
      }

      firebaseToken.current = token;
      this.$store.commit('firebaseToken', firebaseToken);

      if (this.$store.state.userData.drf_token) {
        const deviceInfo = await Device.getInfo();
        let data = JSON.parse(JSON.stringify(this.$store.state.firebaseToken));
        data.current = token;
        data.device_type = deviceInfo.platform;

        let response;
        try {
            response = await fetch(`${API_URL}users/firebase_token/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${this.$store.state.userData.drf_token}`
                },
                body: JSON.stringify(data)
            });
        }
        catch(e) {
            console.error(e);
        }

        if (response && [200, 401].includes(response.status)) {
            if (response.status == 200) {
                let firebaseToken = JSON.parse(JSON.stringify(this.$store.state.firebaseToken));
                firebaseToken.current = data.current;
                firebaseToken.old = [];
                this.$store.commit('firebaseToken', firebaseToken);

                // For PWA, also store in Firestore for Firebase Functions access
                if (this.$store.state.appPlatform === 'web') {
                  try {
                    if (!firebase.apps.length) {
                      console.warn("Firebase has not been initialized. Skipping.");
                      return;
                    }

                    // Ensure Firebase Auth is properly initialized and user is signed in
                    await import("firebase/auth");
                    const auth = firebase.auth();
                    
                    // Wait for auth state to be ready
                    await new Promise((resolve) => {
                      const unsubscribe = auth.onAuthStateChanged((user) => {
                        unsubscribe();
                        resolve(user);
                      });
                    });
                    
                    if (!auth.currentUser) {
                      console.log('Not authenticated with Firebase, signing in anonymously...');
                      await auth.signInAnonymously();
                      console.log('Successfully signed in anonymously');
                    }

                    console.log('Firebase Auth current user:', auth.currentUser?.uid);

                    // Firebase v8 syntax for Firestore
                    await import("firebase/firestore");
                    const db = firebase.firestore();
                    
                    const userId = this.$store.state.userData.id.toString();
                    console.log('Attempting to store FCM token in Firestore for user:', userId);
                    
                    await db.collection('users').doc(userId).set({
                      fcmToken: token,
                      lastUpdated: new Date(),
                      userId: this.$store.state.userData.id,
                      firebaseAuthUid: auth.currentUser.uid // Add this for debugging
                    }, { merge: true });
                    
                    console.log('FCM token stored in Firestore successfully');
                  } catch (error) {
                    console.error('Error storing FCM token in Firestore:', error);
                    console.error('Error code:', error.code);
                    console.error('Error message:', error.message);
                    
                    // Log additional debugging info
                    if (error.code === 'permission-denied') {
                      console.error('Permission denied - check Firestore rules and authentication');
                      console.error('Current user:', firebase.auth().currentUser);
                    }
                  }
                }
            }
        }
      }
    },
    async handleNotification(notificationObj) {
      const notification = ('notification' in notificationObj) ? 
        JSON.parse(JSON.stringify(notificationObj.notification)) :
        JSON.parse(JSON.stringify(notificationObj));

      if (
        'data' in notification &&
        ['sync_request',
        'sync_approved',
        ].includes(notification.data.notification_type)) {
          this.$store.commit('syncUpdate');
          if (this.$route.name != "sync") {
            this.$router.push({
              name: "sync",
            });
          }
      } else if (
        'data' in notification &&
        ['love_list', // what's new
        'memories_list',
        'bucket_list',
        'fantasies_list',
        ].includes(notification.data.notification_type)) {
          this.$router.push({
            name: notification.data.notification_type,
          });
      } else if (
        'data' in notification &&
        'shared_playlist' === notification.data.notification_type
      ) {
        this.$router.push({
          name: 'playlist',
        });
      } else if (
        'data' in notification &&
        'calendar' === notification.data.notification_type
      ) {
        this.$router.push({
          name: 'calendar',
        });
      } else if (
        'data' in notification &&
        'sexploration_list_complete' === notification.data.notification_type
      ) {
        this.$router.push({
          name: 'exploration_list',
        });
      } else if (
        'data' in notification &&
        ['whats_new', // what's new
        ].includes(notification.data.notification_type)) {
          this.$router.push({
            name: 'whats_new',
          });
      } else if (
        'data' in notification &&
        notification.data.notification_type == 'profile_update' && this.userData && this.userData.drf_token
      ) {
        // Force update profile
        console.log("Updating profile because noticiation said to");

        let response;

        try {
          response = await fetch(
            `${API_URL}users/user_data/`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Token ${this.userData.drf_token}`,
              },
              body: this.formData,
            }
          );
        }
        catch(e) {} // eslint-disable-line no-empty

        if (response.status == 200) {
          let responseJson = await response.json();
          this.$store.commit('userData', responseJson);
        }
      } else if (
        'data' in notification &&
        ['new_badge', 'new_milestone'].includes(notification.data.notification_type)
      ) {
        this.$router.push({
          name: 'badges',
        });
      } else if (
        'data' in notification &&
        notification.data.notification_type === 'local_reminder'
      ) {
        // Handle local reminder notifications
        this.$router.push({
          name: "home",
        });
      } else {
        this.$router.push({
          name: "home",
        });
      }
    },
    async handleFirebase() {
      let permStatus = await PushNotifications.checkPermissions();
      if (permStatus.receive === "prompt") {
          permStatus = await PushNotifications.requestPermissions();
      }
      if (permStatus.receive === "granted") {
        await PushNotifications.addListener("registration", async (token) => {
          console.log("Push Registration Token: " + token.value);
          await this.sendTokenToServer(token.value);
        });
        await PushNotifications.addListener("registrationError", (error) => {
          console.log("Push Registration Error: " + error.error);
        });

        await PushNotifications.addListener("pushNotificationReceived", (notification) => this.handleNotification(notification));
        await PushNotifications.register();
      }
    },
    async handleFirebaseWeb() {
      // Initialize Firebase v8 style
      const firebaseConfig = {
        apiKey: process.env.FIREBASE_WEB_PUSH_KEY,
        authDomain: "intimately-us.firebaseapp.com",
        databaseURL: "https://intimately-us.firebaseio.com",
        projectId: "intimately-us",
        storageBucket: "intimately-us.appspot.com",
        messagingSenderId: "436220440631",
        appId: "1:436220440631:web:589aa4051f7a6f6d7ecfb2",
        measurementId: "G-FVRB5EJK2H",
        vapidKey: process.env.FIREBASE_WEB_VAPIKEY
      };

      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }

      // Initialize Auth FIRST and wait for it to complete
      try {
        await import("firebase/auth");
        const auth = firebase.auth();
        
        // Wait for auth state to be ready
        await new Promise((resolve) => {
          const unsubscribe = auth.onAuthStateChanged((user) => {
            unsubscribe();
            resolve(user);
          });
        });
        
        // Sign in anonymously if not already authenticated
        if (!auth.currentUser) {
          console.log('Signing in anonymously to Firebase...');
          await auth.signInAnonymously();
          console.log('Successfully signed in anonymously to Firebase');
          console.log('Firebase user UID:', auth.currentUser.uid);
        } else {
          console.log('Already authenticated with Firebase, UID:', auth.currentUser.uid);
        }
      } catch (error) {
        console.error('Error authenticating with Firebase:', error);
      }

      // Now initialize messaging
      const messaging = firebase.messaging();

      try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          const token = await messaging.getToken({
            vapidKey: process.env.FIREBASE_WEB_VAPIKEY,
          });

          console.log("Firebase web push token is: ", token);
          this.sendTokenToServer(token);

          // handle foreground messages
          messaging.onMessage((payload) => {
            console.log("Received a push message:", payload);
            this.handleNotification(payload);
          });
        } else {
          console.log("User blocked notifications");
        }
      } catch (error) {
        console.error("Error initializing Firebase Messaging", error);
      }
    },
    async testScheduleReminder() {
      if (this.$store.state.appPlatform === 'web') {
        try {
          // Firebase v8 syntax for Functions
          const functions = firebase.functions();
          const scheduleReminder = functions.httpsCallable('scheduleReminder');
          
          const result = await scheduleReminder({
            userId: this.$store.state.userData.id.toString(),
            reminders: this.$store.state.reminderSettings || {}
          });
          
          console.log('Test reminder scheduled:', result);
        } catch (error) {
          console.error('Error scheduling test reminder:', error);
        }
      }
    },
  }
}